import { useTruncatedText } from "@/hooks/useTruncatedText";
import { appstr } from "@coreapp/utils/appstr";
import { Button, Text } from "@theorgchartdev/storybook";
import { useRef } from "react";

interface TruncatedTextProps {
  text: string;
  maxLines: number;
}

export const TruncatedText = ({ text, maxLines }: TruncatedTextProps) => {
  const textRef = useRef<HTMLDivElement>(null);
  const { isTruncated, isReadingMore, setIsReadingMore } = useTruncatedText(textRef);

  return (
    <>
      <Text
        className={"ocn-truncated-text"}
        ref={textRef}
        size="small"
        style={{ WebkitLineClamp: isReadingMore ? "none" : maxLines }}
      >
        {text}
      </Text>
      {isTruncated && !isReadingMore && (
        <Button
          modifier="link"
          onClick={() => setIsReadingMore(true)}
          size="small"
          className="ocn-truncated-text-button"
        >
          {appstr("Show more")}
        </Button>
      )}
      {isReadingMore && (
        <Button
          modifier="link"
          onClick={() => setIsReadingMore(false)}
          size="small"
          className="ocn-truncated-text-button"
        >
          {appstr("Show less")}
        </Button>
      )}
    </>
  );
};
